import { LayoutGrid } from "lucide-react";
import {
  QuickAccessParamsSchema,
  defaultQuickAccessParams,
  type QuickAccessParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { QuickAccessWidget } from "./Component.js";
import { QuickAccessEditor } from "./Editor.js";
import type { QuickAccessView } from "./types.js";

export const quickAccessDef: SqlWidgetDef<QuickAccessParams, QuickAccessView> =
  {
    kind: "quickAccess",
    label: "Quick Access",
    modes: ["dashboard"],
    singleton: true,
    defaultSize: { w: 360, h: 320 },
    defaultParams: defaultQuickAccessParams,
    Component: QuickAccessWidget,
    storage: "sql",
    schema: QuickAccessParamsSchema,
    accent: "neutral",
    icon: LayoutGrid,
    subtitle: "Workspace modules",
    defaultRoster: false,
    category: "single",
    layout: { col: 1, row: 1, width: 360, height: 320 },
    dashboard: {
      icon: LayoutGrid,
      defaultWidth: "medium",
      category: "Personal",
      EditorForm: QuickAccessEditor,
    },
  };

registerWidget(quickAccessDef);
